import React, { Component, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as router from "react-router-dom";
import { Container } from "reactstrap";
import IdleTimer from "react-idle-timer";

import {
  AppAside,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav,
} from "@coreui/react";
// sidebar nav config
import navigation from "../../_nav";
// routes config
import routes from "../../routes";
import LoadingCustom from "../../common/LoadingCustom";
import { AsyncStorage } from "AsyncStorage";
import ServiceUser from "../../archers_services/ServiceUser";
import {
  CustomNotifMessage,
  IntegrationNotistackCustom,
  LogOut,
} from "../../common";
import ServiceResponse from "../../archers_services/ServiceResponse";
import { array } from "prop-types";
import ServiceFailErreur from "../../archers_services/ServiceFailErreur";
import axios from "axios";
import { API_TOKEN_INFO } from "../../archers_services/ServiceAPI";
import ErrorPage from "../../views/Dashboard/ErrorPage";
import { ServiceRedirect } from "../../archers_services/ServiceRedirect";
import { red } from "@material-ui/core/colors";
import ServiceLogout from "../../archers_services/ServiceLogout";
const DefaultAside = React.lazy(() => import("./DefaultAside"));
const DefaultFooter = React.lazy(() => import("./DefaultFooter"));
const DefaultHeader = React.lazy(() => import("./DefaultHeader"));
const loading = () => (
  <div>
    <LoadingCustom />
  </div>
);

class DefaultLayout extends Component {
  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.state = {
      timeout: 900000,
      remaining: null,
      isIdle: false,
      lougout: false,
      lastActive: null,
      elapsed: null,

      isLoading: false,
      isLoadingFilter: false,
      tokenInvalid: false,
      error: "",
      message: "",
      resp: {
        message: "",
        error: "",
        data: null,
        isInvalideToken: false,
      },
      pathErreur: "",
    };
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
  }

  _onActive() {
    this.setState({ isIdle: false });
  }

  _onIdle() {
    this.setState({ isIdle: true, lougout: true });
  }

  componentDidMount() {
    this.getInfoToken();
  }

  filterNav = (data) => {
    if (this.state.isLoading && this.state.isLoadingFilter === false) {
      this.dataResponse = this.state.resp.data;
      this.setState({
        isLoadingFilter: true,
      });
      if (this.dataResponse !== undefined && this.dataResponse !== null) {
        if (
          this.dataResponse.roles !== undefined &&
          this.dataResponse.roles !== null
        ) {
          if (this.dataResponse.roles.includes("SUPER_ADMIN")) {
            return (
              data.role === "all" ||
              data.role === "admin" ||
              data.role === "super_admin"
            );
          }
          if (this.dataResponse.roles.includes("ADMIN")) {
            return (
              data.role === "all" ||
              data.role === "admin" ||
              data.role === "admin_exclusif"
            );
          }
          if (this.dataResponse.roles.includes("FME")) {
            return data.role === "fme";
          }
        }
      }
    }
  };

  filterRoutes = (data) => {
    if (this.state.isLoadingFilter) {
      this.dataResponse = this.state.resp.data;
      if (this.dataResponse !== undefined && this.dataResponse !== null) {
        if (
          this.dataResponse.roles !== undefined &&
          this.dataResponse.roles !== null
        ) {
          if (this.dataResponse.roles.includes("SUPER_ADMIN")) {
            return (
              data.role === "all" ||
              data.role === "admin" ||
              data.role === "super_admin"
            );
          }
          if (this.dataResponse.roles.includes("ADMIN")) {
            return (
              data.role === "all" ||
              data.role === "admin" ||
              data.role === "admin_exclusif"
            );
          }
          if (this.dataResponse.roles.includes("FME")) {
            return data.role === "fme";
          }
        }
      }
    }
  };

  getInfoToken() {
    AsyncStorage.getItem("app_archers_token").then((token) => {
      const config = {
        headers: { Authorization: `${token}` },
        "Content-Type": "application/json",
      };
      axios.get(API_TOKEN_INFO, config).then(
        (response) => {
          this.setState(
            {
              resp: ServiceResponse.getResponseNotMessage(response),
              isLoading: true,
            },
            () => (navigation.items = navigation.items.filter(this.filterNav))
          );
        },
        (error) => {
          this.setState(
            {
              resp: ServiceResponse.getResponseError(error),
              tokenInvalid: ServiceFailErreur.invalidTokenRequered(error),
              isLoading: true,
            },
            () => {
              this.setState({
                pathErreur: this.state.resp.error,
              });
            }
          );
        }
      );
    });
  }

  onLoand() {
    var s = document.getElementById("minim_id_button");
    if (s !== null) {
      s.click();
    }
  }

  logout() {
    return <ServiceLogout />;
  }

  getContent() {
    return (
      <div className="app" onLoad={() => {}}>
        <IdleTimer
          // ref={ref => { this.idleTimer = ref }}
          onActive={this.onActive}
          onIdle={this.onIdle}
          timeout={this.state.timeout}
          startOnLoad
        />
        {this.state.lougout ? <ServiceLogout /> : ""}
        <AppHeader fixed>
          <Suspense fallback={loading()}>
            <DefaultHeader
              descreption={this.state.resp.data.fullName}
              username={this.state.resp.data.username}
              onLogout={(e) => this.signOut(e)}
            />
          </Suspense>
        </AppHeader>
        <div className="app-body">
          {this.state.resp.error != undefined && this.state.resp.error != "" ? (
            <IntegrationNotistackCustom
              message={this.state.resp.error}
              variant="error"
              clanMessage={() => {}}
            />
          ) : (
            ""
          )}
          <AppSidebar fixed display="lg" minimized={true}>
            <AppSidebarHeader />
            <AppSidebarForm />
            <Suspense>
              <AppSidebarNav
                navConfig={navigation}
                {...this.props}
                router={router}
              />
            </Suspense>
            <AppSidebarFooter />
            <AppSidebarMinimizer />
          </AppSidebar>

          <main className="main">
            <AppBreadcrumb appRoutes={routes} router={router} />
            <Container fluid>
              <Suspense fallback={loading()}>
                <Switch>
                  {routes.filter(this.filterRoutes).map((route, idx) => {
                    return route.component ? (
                      <Route
                        key={idx}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        role={route.role}
                        render={(props) => <route.component {...props} />}
                      />
                    ) : null;
                  })}
                  <ServiceRedirect link="/dashboard" />
                </Switch>
              </Suspense>
            </Container>
          </main>
          <AppAside fixed>
            <Suspense fallback={loading()}>
              <DefaultAside />
            </Suspense>
          </AppAside>
        </div>

        <AppFooter>
          <Suspense fallback={loading()}>
            <DefaultFooter />
          </Suspense>
        </AppFooter>
      </div>
    );
  }

  render() {
    if (this.state.tokenInvalid) {
      return this.logout();
    }
    if (this.state.pathErreur !== "") {
      return <ErrorPage erreur={this.state.pathErreur} />;
    }
    if (this.state.isLoadingFilter) {
      return this.getContent();
    }
    return <Suspense fallback={loading()} />;
  }
}

export default DefaultLayout;
